/**
 * PC新首页，楼层导航
 * @author yongsheng.zhang
 */
const $ = require('jquery')
const LXBid = require('../../../lib/lx-bid.js')
const LXWrap = require('../../../lib/lx.js')
let param = {
    cityId: window._DP_HeaderData && window._DP_HeaderData.cityId ? window._DP_HeaderData.cityId : 1,
    userId: window._DP_HeaderData && window._DP_HeaderData.userId ? window._DP_HeaderData.userId : null
}
/**
 * 
 * @param {*} fff 
 * @param {*} ffff 
 */
const CataNav = (fff, ffff) => {
    // 楼层导航
    // let cataNavHtml = $(templateCataNav());
    // $('#main-index').append(cataNavHtml);
    let navShowHeight = $('#cata-detail').offset().top;
    let navTop;
    const navPosition = () => {
        let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (windowWidth <= 1270) {
            // 页面宽度小于主内容宽度+导航自身宽度时，不显示楼层导航
            return
        }
        let navHeight = $('#cata-nav').height();
        let mainWidth = $('#main-index').width();
        navTop = (windowHeight - navHeight) / 2;
        let navRight = (windowWidth - mainWidth) / 2;
        $('#main-index').find('.cata-nav').css({'top': `${navTop}px`, 'right': `${navRight + mainWidth}px`});
        if ($(window).scrollTop() > navShowHeight) {
            $('#main-index').find('.cata-nav').show();
        }
    }
    navPosition();
    $('#main-index').find('.cata-nav-detail').on('click', function() {
        $('#main-index .cata-nav-detail').removeClass('current-nav');
        $(this).addClass('current-nav');
        let _cataNavInfo = $(this).attr('data-nav');
        let _cataDefailInfo = $(`#${_cataNavInfo}`);
        $('html,body').animate({scrollTop: `${_cataDefailInfo.offset().top - 210}`});
        // window.scrollTo(0,`${_cataDefailInfo.offset().top - 250}`);
    })

    // 楼层点击打点
    LXWrap($('.cata-nav-detail a'), LXBid.cataNavClickBid, true, false)

    const cataNavScroll = direction => {
        let winTop = $(window).scrollTop();
        if (winTop > navShowHeight) {
            $('#main-index').find('.cata-nav').show();
        } else {
            $('#main-index').find('.cata-nav').hide();
        }
        let cataIndex = $('#main-index').find('.cata-nav-detail').length;
        $('#main-index').find('.cata-nav-detail').each(function(index, item) {
            if (index >= (cataIndex - 1)) return;
            let cataNavInfo = $(this).attr('data-nav');
            let cataDefailInfo = $(`#${cataNavInfo}`);
            // 防止模块不存在但楼层存在
            if (!cataDefailInfo || !cataDefailInfo.offset()) return
            let cataDefailInfoHeight = cataDefailInfo.offset().top - winTop;// 元素距离浏览器顶部的距离
            let commentHeight = 40 * (index + 1);
            if (cataDefailInfoHeight < (navTop + commentHeight)) {
                $('#main-index').find('.cata-nav-detail').eq(index - 1).removeClass('current-nav');
                $(this).addClass('current-nav');
                // 楼层导航曝光打点  
                try {
                    if ($(this).attr('data-nav-linxi') !== 'true') {
                        let linxiName = $(this).find('a').text()
                        let valLab = {
                            'custom': {
                                'city_id': param.cityId,
                                'user_id': param.userId,
                                'click_name': linxiName
                            }
                        }
                        LXAnalytics('moduleView', LXBid.cataNavViewBid, valLab)
                        // 推荐标签
                        LXWrap($(`#${$(this).attr('data-nav')} .cata-tag a`), LXBid.tagViewBid, true, true)
                        // 模块poi曝光
                        LXWrap($(`#${$(this).attr('data-nav')} .view-more`), LXBid.poiViewBid, true, true)
                        LXWrap($(`#${$(this).attr('data-nav')} .shop-item-pic`), LXBid.poiViewBid, true, true)
                        LXWrap($(`#${$(this).attr('data-nav')} .shop-name`), LXBid.poiViewBid, true, true)
                        // 模块主体曝光
                        switch ($(this).attr('data-nav')) {
                        // 美食 休闲娱乐 丽人 亲子 可能存在只有一个模块的情况 
                        case 'cata-part-one':
                            LXWrap($('#cata-food-index'), LXBid.poiViewBid, true, true)
                            LXWrap($('#cata-entertainment-index'), LXBid.poiViewBid, true, true)
                            break
                        case 'cata-part-three':
                            LXWrap($('#cata-beauty-index'), LXBid.poiViewBid, true, true)
                            LXWrap($('#cata-child-index'), LXBid.poiViewBid, true, true)
                            break
                        case 'cata-part-two':
                            LXWrap($('#cata-part-two'), LXBid.picViewBid, true, true)
                            break
                        case 'cata-part-four':
                            LXWrap($('#cata-part-four'), LXBid.picViewBid, true, true)
                            break
                        default:
                            LXWrap($(`#${$(this).attr('data-nav')}`), LXBid.poiViewBid, true, true)
                            break
                        }
                        $(this).attr('data-nav-linxi', 'true');
                    }
                } catch (e) {
                    console.log('linxi nav view err')
                }
            } else {
                $(this).removeClass('current-nav');
                $('#main-index').find('.cata-nav-detail').eq(index + 1).addClass('current-nav');
            }
        });
    }
    $(window).on('scroll', e => {
        cataNavScroll();
    });
    $(window).resize(function() {
        navPosition();
    });
    window.onload = () => {
        cataNavScroll('down');
    }
}

module.exports = CataNav



// WEBPACK FOOTER //
// ./src/pages/index/component/cata-nav.js